/**
 * Build expected_totals for durable-generate.
 *
 * Package IDs and methods are arrays. Families and strategy keys are maps keyed
 * by package_id (never positional parallel arrays — blank/deduped IDs must not
 * shift later entries onto the wrong package).
 *
 * Do not emit parallel count fields (expected_package_count / total_letters /
 * etc.) — those drift from len(ids). Runtime derives counts after lock.
 * expected_package_ids is the single package-ID list (no submitted_package_ids).
 */
export function buildDurableExpectedTotals({
  packages = [],
  methodGroups = [],
} = {}) {
  const previewPackages = Array.isArray(packages) ? packages : [];
  const expectedPackageIds = [];
  const expectedPackageFamilies = {};
  const expectedStrategyRecordKeys = {};
  const seenIds = new Set();

  previewPackages.forEach((pkg) => {
    const packageId = pkg?.package_id == null ? '' : String(pkg.package_id).trim();
    if (!packageId || seenIds.has(packageId)) {
      return;
    }
    seenIds.add(packageId);
    expectedPackageIds.push(packageId);

    const family =
      pkg.package_family
      || pkg.resolved_family
      || pkg.family
      || '';
    if (family) {
      expectedPackageFamilies[packageId] = String(family);
    }

    const strategyKey = pkg.strategy_record_key || pkg.expected_strategy_record_key || '';
    if (strategyKey) {
      expectedStrategyRecordKeys[packageId] = String(strategyKey);
    }
  });

  const groups = Array.isArray(methodGroups) ? methodGroups : [];
  const submittedMethods = groups
    .map((g) => g?.method_key)
    .filter(Boolean)
    .map((key) => String(key));

  return {
    expected_package_ids: expectedPackageIds,
    submitted_methods: submittedMethods,
    expected_package_families: expectedPackageFamilies,
    expected_strategy_record_keys: expectedStrategyRecordKeys,
  };
}
